module.exports = __webpack_public_path__ + "img/2.3284bff1.jpg";